<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>每日数据</el-breadcrumb-item>
    </el-breadcrumb>
    <ex-table
      ref="table"
      :load-and-request="false"
      :request="fetchData"
      :init="initOptions"
    >
      <ex-table-column
        prop="time"
        label="时间"
        align="center"
        width="120"
        search-key="time"
        data-type="date"
        start-time-key="startTime"
        end-time-key="endTime"
      ></ex-table-column>
      <ex-table-column
        prop="timeUnit"
        label="时间单位"
        align="center"
        search-key="timeUnit"
        data-type="select"
        :options="timeUnitOptions"
      ></ex-table-column>
      <ex-table-column
        prop="source"
        label="来源"
        align="center"
        width="120"
        search-key="source"
        data-type="select"
        :options="sourceOptions"
      ></ex-table-column>
      <ex-table-column
        prop="registerType"
        label="平台"
        align="center"
        width="120"
        search-key="registerType"
        data-type="select"
        :options="registerTypeOptions"
      ></ex-table-column>
      <ex-table-column
        prop="totalRegisterCount"
        label="总注册人数"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="validRegisterCount"
        label="有效注册人数"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="activeCount"
        label="活跃人数"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="paidCount"
        label="付费人数"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="totalPaidAmount"
        label="总付费金额"
        align="center"
        :data-type="DataType.MONEY"
      ></ex-table-column>
      <ex-table-column
        prop="onlineMemberPaidAmount"
        label="线上VIP付费金额"
        align="center"
        :data-type="DataType.MONEY"
      ></ex-table-column>
      <ex-table-column
        prop="coinPaidAmount"
        label="金币付费金额"
        align="center"
        :data-type="DataType.MONEY"
      ></ex-table-column>
      <ex-table-column
        prop="arpu"
        label="ARPU"
        align="center"
        :data-type="DataType.MONEY"
      ></ex-table-column>
      <ex-table-column
        prop="arppu"
        label="ARPPU"
        align="center"
        :data-type="DataType.MONEY"
      ></ex-table-column>
    </ex-table>
  </div>
</template>

<script>
import {pageStatDailyData} from "../../api/statMG";
import {DataType} from "../../components/ExTable/ExTableEnum";
import {sourceConfigList} from "../../api/configMG";

export default {
  name: 'DailyData',
  computed: {
    DataType() {
      return DataType
    }
  },
  data() {
    return {
      tableData: [],
      timeUnitOptions: [
        { value: 1, label: '日' },
        { value: 2, label: '月' },
        { value: 3, label: '年' }
      ],
      sourceOptions: [],
      registerTypeOptions: [
        { value: 1, label: '微信小程序' },
        { value: 2, label: '抖音小程序' },
        { value: 3, label: 'PC官网' },
        { value: 4, label: '移动官网' },
        { value: 5, label: 'Android' },
        { value: 6, label: 'IOS' },
        { value: 0, label: '汇总' },
      ]
    };
  },
  methods: {
    async initOptions() {
      let res = await sourceConfigList();
      this.sourceOptions = res.data.concat({value: 0, label: '汇总'});
    },
    async fetchData(params) {
      let res = await pageStatDailyData(params)
      return new Promise((c) => {
        c({
          records: res.data.records,
          total: res.data.total
        })
      })
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.table.search();
    })
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/stat/DailyData.vue